<template>
    <div>
        <h1>RENJA BELANJA TIDAK LANGSUNG</h1>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
